<script lang="ts">
  import { WINDOWS } from '../periods';

  // The insights time-window control: a "Period" eyebrow + a join of window
  // buttons. `days` is bindable so the parent reloads its data on change; an
  // optional `note` explains what the window applies to.
  let { days = $bindable(), note = null }: { days: number; note?: string | null } = $props();
</script>

<div class="flex flex-wrap items-center gap-x-3 gap-y-2">
  <span class="eyebrow text-base-content/65">Period</span>
  <div class="join">
    {#each WINDOWS as w (w.days)}
      <button
        class="btn join-item btn-sm {days === w.days ? 'btn-primary' : 'border hair bg-base-100/80'}"
        onclick={() => (days = w.days)}
        aria-pressed={days === w.days}
      >{w.label}</button>
    {/each}
  </div>
  {#if note}<span class="text-xs text-base-content/65">{note}</span>{/if}
</div>
